import { isDefined } from "@clipboard-health/util-ts";
import { differenceInDays } from "date-fns";

const BADGE_INTRO_DISMISSED_KEY = "badge-intro-dismissed";

function buildKey(workerId: string) {
  return `${BADGE_INTRO_DISMISSED_KEY}::${workerId}`;
}

export function hasWorkerDismissedBadgeIntro(workerId: string): boolean {
  const raw = localStorage.getItem(buildKey(workerId));
  if (!isDefined(raw)) {
    return false;
  }
  return differenceInDays(new Date(), new Date(raw)) < 30;
}

export function markWorkerBadgeIntroDismissed(workerId: string) {
  localStorage.setItem(buildKey(workerId), new Date().toISOString());
}

export function refreshBadgeIntroDismissalIfExists(workerId: string) {
  if (hasWorkerDismissedBadgeIntro(workerId)) {
    markWorkerBadgeIntroDismissed(workerId);
  }
}
